// React
import { useState, createContext, useMemo } from "react";

// Store
import api from "../api/api";
import axios from "axios";
// import diagramConfigInit from "../utils/diagramConfigInit";

export const GetDataContext = createContext();

//Polling Companies
const pollingCompaniesState = [
  { id: 1, name: "Prorata" },
  { id: 2, name: "Marc" },
  { id: 3, name: "Opinionpoll" },
  { id: 4, name: "PulseRC" },
  { id: 5, name: "Alco" },
  { id: 6, name: "MRB" },
  { id: 7, name: "GPO" },
  { id: 8, name: "KapaResearch" },
  { id: 9, name: "MetronAnalysis" },
  { id: 10, name: "PalmosAnalysis" },
  { id: 11, name: "RASS"}
];

//API
const apiUrls = {
  company: "/company",
  configOptions: "/configOptions",
  pollsIntention: "/pollsIntention",
  pollsEvaluation: "/pollsEvaluation",
};

const apiRequests = [];

export const GetDataContextProvider = ({ children }) => {
  const [intData, setIntData] = useState({ type: "intention", data: [] }); // Int stands for Intention
  const [evData, setEvData] = useState({ type: "evaluation", data: [] }); //EV stands for Evaluation
  const [appConfigOptions, setAppConfigOptions] = useState({});
  const [pollingCompanies, setPollingCompanies] = useState([...pollingCompaniesState]);

  const [dataHandlingDone, setDataHandlingDone] = useState(false)
  const [dataMapping, setDataMapping] = useState(false)
console.log(appConfigOptions)
  useMemo(() => {
    const getData = async () => {
      for (let apiUrlsKey in apiUrls) {
        apiRequests.push(api.get(apiUrls[apiUrlsKey]));
      }
      try {
       await axios.all(apiRequests).then(
          axios.spread((...res) => {
            setPollingCompanies(res[0].data);
            setAppConfigOptions(res[1].data);
            setIntData({type: "intention", data: res[2].data});
            setEvData({type: "evaluation", data: res[3].data});
          })
        );
      } catch (error) {
        console.log("error", error);
        return {};
      }
    };
    getData().then(()=> setDataHandlingDone(true));
  }, []);

  return (
    <GetDataContext.Provider
      value={{ intData, evData, appConfigOptions, pollingCompanies, dataHandlingDone, setDataHandlingDone, dataMapping ,setDataMapping }}
    >
      {children}
    </GetDataContext.Provider>
  );
};
